import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// Matches the app's existing brand purple ($primary in dynamic-variables.scss)
// so PrimeNG components (buttons, tags, focus rings) look native to this dashboard.
export const ElGrocerPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f5eff8',
      100: '#e6d7ed',
      200: '#cdaedb',
      300: '#b586c9',
      400: '#9c65ab',
      500: '#75428E',
      600: '#623a78',
      700: '#522E64',
      800: '#422550',
      900: '#301b3a'
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#F8F9FB',
          100: '#f1f2f5',
          200: '#e5e7eb'
        }
      }
    }
  }
});
